import { createSlice } from '@reduxjs/toolkit';
import { login, stayLogin } from './loginThunk';

interface UserState {
  user: {
    id: number;
    email: string;
    name: string;
    role: string;
  };
}

const initialState: UserState = {
  user: {
    id: 0,
    email: '',
    name: '',
    role: '',
  },
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, { payload }) => {
        const { id, email, name, role } = payload.user;
        if (role !== 'admin') throw 'NotAdmin';
        else state.user = { id, email, name, role };
      })
      .addCase(login.rejected, (_, { payload }) => {
        throw payload;
      });
    builder
      .addCase(stayLogin.fulfilled, (state, { payload }) => {
        const { id, email, name, role } = payload;
        if (role !== 'admin') throw 'NotAdmin';
        else state.user = { id, email, name, role };
      })
      .addCase(stayLogin.rejected, (state, { payload }) => {
        state.user = { id: 0, email: '', name: '', role: '' };
        throw payload;
      });
  },
});

export default loginSlice.reducer;
